import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { AuthProvider } from "@/lib/auth-context";
import { useTheme } from "@/lib/theme";
import { BuyFlagsProvider } from "@/lib/buy-flags-context";
import { BugsnagBoundary } from "@/components/BugsnagBoundary";
import { RouteErrorPage } from "@/components/RouteErrorPage";
import { routes } from "./routes";

// Wrap every route in a pathless layout route carrying an `errorElement`, so a
// route-render error (e.g. a lazy chunk that still 404s after lazyWithReload's
// reload) bubbles to our Romanian fallback instead of React Router's default
// "Unexpected Application Error!" screen.
const router = createBrowserRouter([
  { errorElement: <RouteErrorPage />, children: routes },
]);
const queryClient = new QueryClient();

export function App() {
  // Registers the matchMedia listener for the session so a `system` theme
  // follows the OS live. The pre-paint script in index.html has already set
  // the attribute by the time this runs; the settings screen reads the hook
  // again for its controls.
  useTheme();

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BuyFlagsProvider>
            <BugsnagBoundary>
              <RouterProvider router={router} />
            </BugsnagBoundary>
          </BuyFlagsProvider>
        </AuthProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}
